<div class="row">

    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [lineConfig]="lineConfig" [config]="config.title"></kla-title>
    </div>
   <div class="col-lg-6 col-sm-12 col-xs-12" >
        <div class="row chart" #donutPanel>
            <kla-multiple-donut *ngIf="showChart"  [config]="chartConfig" [width]="chartConfig.width "></kla-multiple-donut>
            </div>
         </div>
  </div>
